import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const BaseCard = styled.div<{ className?: string }>`
  background-color: white;
  border-radius: 8px;
  padding: 16px 20px;
  margin: 12px 0;
  position: relative;
  border: 0.5px solid ${theme.colours.newOutline};
  display: flex;
  flex-direction: column;
  min-height: 75px;
  width: 100%;
  min-width: 0;
  overflow: hidden;

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 16px;
  }

  @media (max-width: 767px) {
    padding: 12px 16px;
    min-height: 75px;
    margin: 8px 0;

    &:first-child {
      margin-top: 12px;
    }

    &:last-child {
      margin-bottom: 12px;
    }
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  flex: 1;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow: visible;
  padding: 0;

  @media (max-width: 935px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    position: static;
  }
`;

export const CardMainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  inset-inline-start: 0;
  justify-content: center;
  align-items: flex-start;
  max-width: 33%;

  @media (max-width: 935px) {
    position: static;
    gap: 6px;
    width: 100%;
    max-width: 100%;
    align-items: flex-start;
  }
`;

export const CardInfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  max-width: 33%;
  margin-inline-start: 33%;
  margin-inline-end: 33%;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 935px) {
    gap: 2px;
    width: 100%;
    max-width: 100%;
    margin-inline-start: 0;
    margin-inline-end: 0;
    align-items: flex-start;
  }
`;

export const CardActionColumn = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  inset-inline-end: 0;
  justify-content: center;
  align-items: flex-end;
  max-width: 33%;

  @media (max-width: 935px) {
    position: static;
    width: 100%;
    max-width: 100%;
    align-items: flex-end;
  }
`;

export const CardTitle = styled.h3`
  font-family: ${theme.fonts.SemiBold};
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  margin: 0;
  line-height: 20px;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  @media (max-width: 767px) {
    font-size: 15px;
  }
`;

export const CardInfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  font-size: 12px !important;

  .card-details-text {
    font-family: ${theme.fonts.Regular};
    font-size: 12px !important;
    color: ${theme.colours.blackText};
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 935px) {
    justify-content: flex-start;

    .card-details-text {
      font-size: 12px !important;
      text-align: left;
    }
  }
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 767px) {
    display: flex !important;
    width: 100%;
    justify-content: flex-end;
    min-width: unset;
    gap: 8px;
    flex-shrink: 0;
  }

  .dots-menu-btn {
    background-color: transparent;
    border: 1px solid #d4d4d4;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-family: ${theme.fonts.Regular};
    font-size: 12px;
    color: ${theme.colours.blackText};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${theme.colours.lightGray};
    }

    svg {
      font-size: 16px;
    }
  }

  .activate-btn {
    background-color: #5d9c59;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 6px 12px;
    font-family: ${theme.fonts.Regular};
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.9;
    }
  }

  .copy-link-btn {
    background-color: transparent;
    border: 1px solid #d4d4d4;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-family: ${theme.fonts.Regular};
    font-size: 12px;
    color: ${theme.colours.blackText};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: ${theme.colours.lightGray};
    }

    svg {
      font-size: 16px;
    }
  }
  .expired-label,
  .booked-label {
    background-color: #ffe2d9;
    border: none;
    border-radius: 8px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-family: ${theme.fonts.Regular};
    font-size: 12px;
    line-height: 1;
    color: ${theme.colours.blackText};
    transition: all 0.2s ease;
    white-space: nowrap;
    box-sizing: border-box;

    @media (max-width: 767px) {
      padding: 5px 10px;
      font-size: 12px;
      height: 28px;
    }
  }

  .booked-label {
    background-color: rgb(10, 100, 57);
    color: ${theme.colours.white};
  }
`;
